import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { computed, defineComponent, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import GridsListing from "@/components/layout/cards-container/GridsListing.vue";
import Payment from "./components/Payment.vue";
import CompleteOrder from "./components/CompleteOrder.vue";
import POSConfigModule from "@/store/modules/pos-config";
import BookingModule from "@/store/modules/booking";
import { BookingStep } from "@/constants/booking";
import { ElMessageBox } from "element-plus";
import { PSBErrors } from "@/constants/errors/product-slot-booking";
import { saveUpdatedBooking } from "@/db/updated-bookings";
import { SyncType } from "@/interfaces/store/IBooking";
import { AccountingState, PaymentTool, PromocodeCampaignType, TransactionTypes } from "@/types/db/accounting";
import { BookingState } from "@/types/db/product-slot-booking";
import ScannerModule from "@/store/modules/scanner";
import { addScannedProductToBasket } from "@/utils/helpers/scanner";
import dayjs from "dayjs";
import { createTicketAccountings } from "@/utils/vue-helpers/accounting";
import { Currencies } from "@/constants/currency";
import { hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import { LogService } from "@/services/logging";
import { startProcessing, buildPatchBookingPayload, compareTwoObjects, autoPrintTicket, printLabels, handlePendingPaymentsCheck } from "@/utils/vue-helpers/booking";
import { createCompositeId } from "@/utils/helpers/app";
import { saveUntypedBooking } from "@/db/untyped-booking";
import PrinterConfigModule from "@/store/modules/printers-config";
import { bookingTotalConsideringDiscounts, restToPay } from "@/utils/vue-helpers/new-accountings";
import { cloneDeep } from "lodash";
import { endTransaction, startAndCompleteItalyOrder } from "@/utils/helpers/fiskaly";
import { setCustomerInfo } from "@/utils/helpers/product-slot-booking";
import AppModule from "@/store/modules/app";
export default defineComponent({
  name: "Booking",
  components: {
    GridsListing: GridsListing,
    Payment: Payment,
    CompleteOrder: CompleteOrder
  },
  setup: function setup() {
    var _useI18n = useI18n({
      useScope: "global"
    }),
        t = _useI18n.t;

    var msg = ref("");
    var isLoading = ref(false);
    var hasSelectedConfig = ref(false);
    var ScannerTog = computed(function () {
      return ScannerModule.tog;
    });
    watch(ScannerTog, function () {
      if (ScannerModule.value && ScannerModule.singleListenerOnly) {
        addScannedProductToBasket(ScannerModule.value);
      }
    }, {
      deep: true
    });
    var hasTickets = computed(function () {
      return BookingModule.hasTickets;
    });
    var selectedBookingUUID = computed(function () {
      return BookingModule.selectedBookingUUID;
    });
    var step = computed(function () {
      return BookingModule.bookingStep;
    });
    var isEnabled1 = computed(function () {
      var _BookingModule$select, _BookingModule$applie;

      if (
      /* user can go forcard if he booked tickets */
      hasTickets.value && step.value === BookingStep.Order &&
      /* user pulled paid booking from backend */
      (BookingModule.isEditOrderBooking && restToPay.value === 0 && step.value === BookingStep.Order) !== true) {
        return true;
      }

      if ((restToPay.value / 100 <= BookingModule.confirmedAmountsTotal || BookingModule.doesSupportSplitPayment && BookingModule.splitAmount && BookingModule.confirmedAmountsTotal || canConfirm.value
      /* user can click complete order if it's a card or he entered a cash amount and applied its payment */
      ) && step.value === BookingStep.Payment
      /* user can complete the booking if its fully discounted */
      ) {
        return true;
      }

      if (restToPay.value === 0 && (step.value === BookingStep.Payment || step.value === BookingStep.Discount || step.value === BookingStep.Promocode || step.value === BookingStep.PromocodeCampaigns)) {
        return true;
      }

      if (
      /* user can complete booking if he applied a refund */
      step.value === BookingStep.Refund && restToPay.value === 0) {
        return true;
      }

      if (
      /** Enable user to print a booking that he pulled from backend */
      BookingModule.isEditOrderBooking && restToPay.value === 0 && ((_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.state) === BookingState.Completed) {
        return true;
      }

      if (restToPay.value === 0 && BookingModule.isPromocodeApplied && BookingModule.appliedPromocode && [PromocodeCampaignType.TYPE_VOUCHER, PromocodeCampaignType.TYPE_VOUCHER_SOLD, PromocodeCampaignType.TYPE_GIFT_CARD, PromocodeCampaignType.TYPE_GIFT_CARD_SOLD].includes((_BookingModule$applie = BookingModule.appliedPromocode) === null || _BookingModule$applie === void 0 ? void 0 : _BookingModule$applie.promocode.promoCodeType)) {
        return true;
      }

      return false;
    });
    var amountsTrack = computed(function () {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value];
    });
    var currentPaymentTool = computed(function () {
      if (!amountsTrack.value) return PaymentTool.None;
      return amountsTrack.value.paymentTool;
    });
    var selectedCashCurrency = computed(function () {
      return BookingModule.selectedCashCurrency;
    });
    var canConfirm = computed(function () {
      if (!amountsTrack.value) return false;
      return currentPaymentTool.value === PaymentTool.Cash || currentPaymentTool.value === PaymentTool.CardAuto || currentPaymentTool.value === PaymentTool.CardManual || currentPaymentTool.value === PaymentTool.BankTransfer || currentPaymentTool.value === PaymentTool.Invoice || currentPaymentTool.value === PaymentTool.ToBeInvoiced || currentPaymentTool.value === PaymentTool.Cheque || currentPaymentTool.value === PaymentTool.ChequeVacances || currentPaymentTool.value === PaymentTool.ChequeCulture || currentPaymentTool.value === PaymentTool.PassCulture || currentPaymentTool.value === PaymentTool.Chorus || currentPaymentTool.value === PaymentTool.CE || currentPaymentTool.value === PaymentTool.OCCYG || currentPaymentTool.value === PaymentTool.CouponSport || currentPaymentTool.value === PaymentTool.PosReka || currentPaymentTool.value === PaymentTool.DiverseVoucher || currentPaymentTool.value === PaymentTool.CFF || currentPaymentTool.value === PaymentTool.CGN || currentPaymentTool.value === PaymentTool.QOQA || currentPaymentTool.value === PaymentTool.DEINDEAL || currentPaymentTool.value === PaymentTool.REALDEAL;
    });
    var total = computed(function () {
      return bookingTotalConsideringDiscounts.value;
    });
    var whatIsLeftToPay = computed(function () {
      return (restToPay.value / 100).toFixed(2);
    });
    var whatIsLeftToPayConverted = computed(function () {
      var _selectedCashCurrency;

      return (restToPay.value / 100 * (((_selectedCashCurrency = selectedCashCurrency.value) === null || _selectedCashCurrency === void 0 ? void 0 : _selectedCashCurrency.exchangeRate) || 1)).toFixed(2);
    });
    var selectedBooking = computed(function () {
      return BookingModule.selectedBooking;
    });
    var IsEditOrder = computed(function () {
      return BookingModule.isEditOrderBooking;
    });
    var currency = computed(function () {
      var _selectedCashCurrency2, _BookingModule$select2;

      return ((_selectedCashCurrency2 = selectedCashCurrency.value) === null || _selectedCashCurrency2 === void 0 ? void 0 : _selectedCashCurrency2.label) || ((_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.currency) || Currencies.CHF;
    });
    var bookingButtonText = computed(function () {
      var booking = BookingModule.selectedBooking;

      if (!booking) {
        return;
      }

      if (hasTickets.value) {
        var _BookingModule$applie2;

        if (step.value === BookingStep.Order && !BookingModule.isFreeBooking) {
          return "".concat(t("button.continue-to-payment"), " | ").concat(currency.value, " ").concat(whatIsLeftToPayConverted.value);
        }

        if (step.value === BookingStep.Refund) {
          return t("button.complete-order");
        }

        if (restToPay.value
        /*BookingModule.leftToPayAmount*/
        === 0 && BookingModule.isPromocodeApplied && BookingModule.appliedPromocode && [PromocodeCampaignType.TYPE_VOUCHER, PromocodeCampaignType.TYPE_VOUCHER_SOLD, PromocodeCampaignType.TYPE_GIFT_CARD, PromocodeCampaignType.TYPE_GIFT_CARD_SOLD].includes((_BookingModule$applie2 = BookingModule.appliedPromocode) === null || _BookingModule$applie2 === void 0 ? void 0 : _BookingModule$applie2.promocode.promoCodeType)) {
          return "".concat(t("button.complete-order"), " | ").concat(currency.value, " ").concat(whatIsLeftToPayConverted.value);
        }

        if (step.value === BookingStep.Payment || step.value === BookingStep.Discount || step.value === BookingStep.Promocode || step.value === BookingStep.PromocodeCampaigns || restToPay.value
        /*BookingModule.pssSumFinaValues*/
        === 0) {
          if (BookingModule.doesSupportSplitPayment && BookingModule.splitAmount) {
            var splitAmountProvided = BookingModule.splitAmount.splitAmountProvided;

            if (currentPaymentTool.value === PaymentTool.Cash && selectedCashCurrency.value) {
              splitAmountProvided = splitAmountProvided * selectedCashCurrency.value.exchangeRate;
            }

            return "".concat(t("button.confirm-payment"), " | ").concat(currency.value, " ").concat(splitAmountProvided.toFixed(2));
          } else {
            var amount = Number(whatIsLeftToPay.value);

            if (currentPaymentTool.value === PaymentTool.Cash) {
              var _selectedCashCurrency3;

              amount = amount * (((_selectedCashCurrency3 = selectedCashCurrency.value) === null || _selectedCashCurrency3 === void 0 ? void 0 : _selectedCashCurrency3.exchangeRate) || 1);
            }

            return "".concat(t("button.complete-order"), " | ").concat(currency.value, " ").concat(amount.toFixed(2));
          }
        }
      }

      return t("button.select-product-to-continue");
    });
    hasSelectedConfig.value = Boolean(POSConfigModule.selectedConfig);
    var showSyncButton = computed(function () {
      return POSConfigModule.completeBookingWithBalance && restToPay.value
      /*BookingModule.leftToPayAmount*/
      !== 0;
    });
    var isAcompteBooking = computed(function () {
      return BookingModule.isAcompteBooking;
    });
    return {
      t: t,
      msg: msg,
      hasSelectedConfig: hasSelectedConfig,
      hasTickets: hasTickets,
      isEnabled1: isEnabled1,
      isLoading: isLoading,
      step: step,
      bookingButtonText: bookingButtonText,
      BookingStep: BookingStep,
      selectedBookingUUID: selectedBookingUUID,
      total: total,
      currency: currency,
      selectedBooking: selectedBooking,
      IsEditOrder: IsEditOrder,
      hasSalesStarted: hasSalesStarted,
      showSyncButton: showSyncButton,
      isAcompteBooking: isAcompteBooking,
      startProcessing: startProcessing,
      buildPatchBookingPayload: buildPatchBookingPayload,
      compareTwoObjects: compareTwoObjects
    };
  },
  methods: {
    cancelOrder: function cancelOrder() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var booking, _yield$handlePendingP, canClose, promptedForConfirmation, confirmation;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                booking = BookingModule.selectedBooking;

                if (booking) {
                  _context.next = 3;
                  break;
                }

                throw new Error(PSBErrors.NoBookingInModule);

              case 3:
                _context.next = 5;
                return handlePendingPaymentsCheck(booking);

              case 5:
                _yield$handlePendingP = _context.sent;
                canClose = _yield$handlePendingP.canClose;
                promptedForConfirmation = _yield$handlePendingP.promptedForConfirmation;

                if (canClose) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                if (promptedForConfirmation) {
                  _context.next = 16;
                  break;
                }

                _context.next = 13;
                return new Promise(function (resolve) {
                  ElMessageBox.confirm("".concat(_this.t("cancel-order.message")), "".concat(_this.t("cancel-order.cancel-order")), {
                    confirmButtonText: "".concat(_this.t("button.confirm")),
                    cancelButtonText: "".concat(_this.t("button.cancel")),
                    type: "warning"
                  }).then(function () {
                    resolve(true);
                  }).catch(function () {
                    resolve(false);
                  });
                });

              case 13:
                confirmation = _context.sent;

                if (confirmation) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("return");

              case 16:
                LogService.info("Cancelling the booking: ".concat(String(_this.selectedBookingUUID)));
                _this.isLoading = false;
                _context.next = 20;
                return BookingModule.clearBooking();

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    fillBooking: function fillBooking() {
      // If there is no booking and we have everything to create a booking (config selected and PSCs pulled) then lets create a new booking
      var bookingsCount = Object.values(BookingModule.bookings).length; // the below variable is true if pos config is selected

      var canCreate = POSConfigModule.selectedConfig;

      if (bookingsCount === 0 && canCreate) {
        // We need to keep the same UI for the user, to do so we need to create a new booking for the user after app update
        LogService.info("App mounted without no bookings, going to create a new booking since there is none");
        BookingModule.createNewBooking();
      }
    },
    confirmSyncPartiallyPaidBooking: function confirmSyncPartiallyPaidBooking() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                msg = "".concat(_this2.t("partially-paid-booking.balance"), " <b> ").concat(_this2.currency + " " + (restToPay.value
                /*BookingModule.leftToPayAmount*/
                / 100).toFixed(2), " </b>, <br>\n        ").concat(_this2.t("partially-paid-booking.confirm"), ".");
                _context2.next = 4;
                return ElMessageBox.confirm("", "".concat(_this2.t("order.confirm")), {
                  confirmButtonText: "".concat(_this2.t("button.confirm")),
                  cancelButtonText: "".concat(_this2.t("button.cancel")),
                  type: "warning",
                  message: msg,
                  dangerouslyUseHTMLString: true,
                  customClass: "custom-message-box"
                });

              case 4:
                LogService.info("User confirmed synching of partially paid booking: ".concat(_this2.selectedBookingUUID));
                _context2.next = 7;
                return _this2.syncPartiallyPaidBooking();

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.error("Sync order cancelation");

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 9]]);
      }))();
    },
    syncPartiallyPaidBooking: function syncPartiallyPaidBooking() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _BookingModule$synche;

        var newBooking, synchedOriginalBooking, diffObject, creationTime, updatedBooking;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!BookingModule.selectedBooking || !BookingModule.selectedBooking.uuid)) {
                  _context3.next = 2;
                  break;
                }

                throw new Error(PSBErrors.NoBookingInModule);

              case 2:
                // Create ticket type accountings for the booking
                // TODO POS: Below, before creating TICKET type accountings we need to check whether a PSS has already TICKET type accounting or not yet.
                newBooking = Object.assign({}, BookingModule.selectedBooking);
                createTicketAccountings(BookingModule.selectedBooking).forEach(function (ticketAcc) {
                  newBooking.accountings.push(ticketAcc);
                });
                BookingModule.updateBooking(newBooking); // Create/Update TAX accounting for the booking
                // updateTaxAccounting();
                // TODO POS: If the booking has generic discount accountings, or discount codes accountings, or payment codes accountings
                // then they are in Pending state and we need to confirm them before moving the booking to backend

                _this3.completeCodeAccountings();

                _context3.next = 8;
                return BookingModule.completeSelectedBooking();

              case 8:
                // save customer info
                setCustomerInfo(newBooking);
                synchedOriginalBooking = (_BookingModule$synche = BookingModule.synchedBookings[BookingModule.selectedBooking.uuid]) === null || _BookingModule$synche === void 0 ? void 0 : _BookingModule$synche.booking; // Save the diff and the booking in its final shape in DB

                if (!synchedOriginalBooking) {
                  _context3.next = 24;
                  break;
                }

                // this booking is synced previously, so let's save the diff object
                console.log("calling buildPatchBookingPayload 7");
                diffObject = buildPatchBookingPayload(synchedOriginalBooking, BookingModule.selectedBooking);
                creationTime = dayjs().toISOString();
                updatedBooking = {
                  _id: createCompositeId([creationTime, BookingModule.selectedBooking.uuid]),
                  uuid: BookingModule.selectedBooking.uuid,
                  diffObject: diffObject
                };
                _context3.prev = 15;
                _context3.next = 18;
                return saveUpdatedBooking(updatedBooking);

              case 18:
                //add booking uuid to the list of synced bookings if it is not edited booking
                BookingModule.storeBookingInPendingSyncBookings({
                  bookingUUID: BookingModule.selectedBooking.uuid,
                  type: SyncType.PUT
                });
                _context3.next = 24;
                break;

              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3["catch"](15);
                LogService.info("Error when saving the booking diff object to indexedDB, booking: ".concat(updatedBooking.diffObject.booking.uuid), {
                  params: {
                    booking: updatedBooking,
                    error: _context3.t0
                  }
                });

              case 24:
                _context3.prev = 24;
                // Save the booking into indexedDB, and sync it to backend
                // await saveBooking(BookingModule.selectedBooking);
                saveUntypedBooking(BookingModule.selectedBooking);
                BookingModule.setBookingStep(_defineProperty({}, BookingModule.selectedBooking.uuid, BookingStep.CompleteOrder)); // auto print tickets/labels

                if (PrinterConfigModule.hasAutoPrinting) {
                  if (PrinterConfigModule.isTicketPrintingEnabled) {
                    autoPrintTicket();
                  }

                  if (PrinterConfigModule.isLabelPrintingEnabled) {
                    printLabels();
                  }
                } // complete the transaction


                endTransaction(BookingModule.selectedBooking); // complete italy order session and sign it

                _context3.prev = 29;
                AppModule.updatedIsLoading(true);
                _context3.next = 33;
                return startAndCompleteItalyOrder(BookingModule.selectedBooking);

              case 33:
                _context3.next = 38;
                break;

              case 35:
                _context3.prev = 35;
                _context3.t1 = _context3["catch"](29);
                LogService.info("Failed to complete italy order", {
                  error: _context3.t1
                });

              case 38:
                _context3.prev = 38;
                AppModule.updatedIsLoading(false);
                return _context3.finish(38);

              case 41:
                return _context3.abrupt("return");

              case 44:
                _context3.prev = 44;
                _context3.t2 = _context3["catch"](24);
                LogService.info("Error when saving the booking to indexedDB, booking: ".concat(BookingModule.selectedBooking.uuid), {
                  params: {
                    booking: BookingModule.selectedBooking,
                    error: _context3.t2
                  }
                });

              case 47:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[15, 21], [24, 44], [29, 35, 38, 41]]);
      }))();
    },
    goBack: function goBack() {
      var selectedBookingUUID = BookingModule.selectedBookingUUID;

      var bs = _defineProperty({}, String(selectedBookingUUID), BookingStep.Order);

      BookingModule.setBookingStep(bs);
      return;
    },
    completeCodeAccountings: function completeCodeAccountings() {
      // If the booking has generic discount accountings, or discount codes accountings, or payment codes accountings
      // then they are in Pending state and we need to confirm them before moving the booking to backend
      LogService.info("Completing generic discount and applied code accountings of the booking because it will be synched with balance");
      var bookingCopy = cloneDeep(BookingModule.selectedBooking);

      for (var i = 0; i < bookingCopy.accountings.length; i++) {
        if (!bookingCopy.accountings[i].refund) {
          if (bookingCopy.accountings[i].promoCodeId || bookingCopy.accountings[i].promoCodeUuid || bookingCopy.accountings[i].promocode || bookingCopy.accountings[i].transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT) {
            // So this accounting is of type discount or payment of code applied
            if (bookingCopy.accountings[i].state === AccountingState.Pending && !bookingCopy.accountings[i].id) {
              // We complete only the ones that were created by the user recently
              // for instance, we don't complete the ones coming from backend
              bookingCopy.accountings[i].state = AccountingState.Completed;
            }
          }
        }
      } // Lets now flag this booking to be POSTed even though it has code applied in it


      bookingCopy.isToBePartiallySynched = true;
      BookingModule.updateBooking(bookingCopy);
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // BOO-1232: This function is not needed anymore
              // As soon as the cashfloat is created, a new booking gets
              // created.
              // But we could be in a case where the app updates and the organiser
              // will see a blank page. We should create a new booking for the user
              // in this case.
              if (_this4.hasSalesStarted) {
                _this4.fillBooking();
              }

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
});